var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRf2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "url(#pattern0_874_672)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_874_672",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_874_672",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_874_672",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAADRklEQVRYw7WXb0xOURzHb/W990n1aL2gGjNsFLOYTCvC5E21YazojT+JjcmMF15iXpnR/Gk2ZUYjJqoXvDHmRZYp/cHmTyJNNCFKT4o6vvf2pHvrVp7nHr+zPee537v9Puf+zu+c8zuK4jUsxwW8wU8Ih60br1GARMVsCEep8fIralDpsNWi3fBVrIUNuX9G4QVSEgIVCRYZhFTGQqDaFToAKOPDpZAJikTTwlBCr0UDsefo5brXTXWjCf2IVzi1AinKfzCspedTCqP1RU7sR4RJgwf1ChOzxpYfjrmmNk3T/PiGBrQp/IxKmzw4z/hZ87sPFdgNl0+Ap+i0BWAX1ZcoNLVrqCJCoBnJMgB6is0eEdMo5OE3erHBOaCc6mSm2jLs97YszDLepKCDs7ZYEoBbh3kWbqtTqKVxdmpEgBxAN95ivdFycYfae1cE1av8ly4LUGtSD1K9aAROoFAOwIO6ITUhkJn1PSGQSdyLR3IAXVyJZv0yhDqT/Qc0/R/AQ/ToK9r6ZU4AP/DEpK6mepf9PPbX5QA68RyRWpQWjXgcRg88aizVY3y7SQ7gm2UdNOvbuhrD3GoJDpED2MPTrhQ3cQOnsRkTqUzlDimQJWklW00EIAOtfHNU3l40n+Pegq3I5recNMb+C/tk7KY6YBL7NsscdOGKGiPnPBgE9OIddmA7crARye5gn0+0cQE9eKw4ML8BLEnCzW20osFPAE/m4fVomVxACR4g3dTy0S4X0IgjlmfWhuoMf7NoBIAx78e6sZXxAflUc3lQCpQPm94YHKCabQlROj6iGEm+AOK8F5E+rDLrPNM6xrh6JP4zwECcZXW31Kq6AREtjou9FsfJ4oRYov9L9QFgbzogQmwTaRbAHJEjYuUAuJ+2jhqgfnWBY4CRMdWGu0xT5V1lKNN9mOQxEfcNdwtNyj19/HblvX+AlTiDQ5FBJmUFlZ2jrwNL9SbXeGP+pP+0m8cj0b3LGDxv5TYJJgWQSc95CpLYNXqvzBLNFYEW7lFxOqmYiBLVLdn9LXo9ZzzwVq7ndhPW+HOTtI19BkcvUPH3FHeFosjIbg9eMbWctQZOLdcFCoYVCVjE6q0en1mPOmttqONlMW7Q7x9tyF0laxmCMQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf2);
export default __webpack_public_path__ + "static/media/rf2.b832a25965c96e5637e20375a5c1452e.svg";
export { ForwardRef as ReactComponent };